<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div class="w-100" [innerHTML]='"copy.html.FIBWelcome.WelcomeCopy"|copy|async'></div>
        <div [innerHTML]='"home.hometext"|content|async' class="login-info"></div>
    </div>
</div>